module.exports = __webpack_public_path__ + "img/memoriale.cb930cb2.jpg";